import { Component, OnInit, Input, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { FieldConfig } from "../../../interfaces/field.interface";
import { PessoaProvider } from "src/app/services/pessoa/pessoa";
import { UserProvider } from "src/app/services/user/user";
import { CadastroProvider } from "src/app/services/cadastro/cadastro";
import { IonicModule, IonSearchbar, NavParams } from "@ionic/angular";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
@Component({
  selector: "app-profissao-select",
  template: `
    <ion-item [formGroup]="group" (click)="openModal()">
      <div style="width: 100%; display: flex;justify-content: space-between; flex-direction: column;">
        <ion-label>
          {{(field.label ?? '') | translate }}
          <span *ngIf="field.validations && field.validations[0]?.name === 'required'" class="danger">*</span>
        </ion-label>

        <ion-text color="medium" class="edit-text">
          {{ getSelectedLabel() || ('Selecione' | translate) }}
        </ion-text>
      </div>
      <div>
        <ion-icon name="caret-down-outline" slot="end" color="medium" style="font-size: 14px;"></ion-icon>
      </div>
    </ion-item>

    <ion-modal [isOpen]="isModalOpen" (didDismiss)="isModalOpen = false">
      <ng-template>
        <ion-header class="extendido">
          <ion-buttons left>
            <ion-button (click)="closeModal()">
              <i class="fa-regular fa-chevron-left chevron-back-button"></i>
            </ion-button>

            <ion-title>{{ "Profissão" | translate }}</ion-title>
          </ion-buttons>
        </ion-header>

        <ion-content>
          <div class="gradient-extendido"></div>

          <ion-searchbar
            #searchbar
            (ionInput)="filterProfissoes($event)"
            (ionCancel)="cancelar()"
            placeholder="{{ 'Buscar profissão...' | translate }}"
            show-cancel-button="never"
          >
          </ion-searchbar>

          <ion-list>
            <ion-radio-group [(ngModel)]="field.value">
              <ion-item *ngFor="let opt of filteredOptions" (click)="selectProfissao(opt)">
                <ion-radio [value]="opt.value" labelPlacement="start">{{ opt.label }}</ion-radio>
              </ion-item>
            </ion-radio-group>

            <ion-item *ngIf="filteredOptions.length === 0">
              {{ "Profissão não encontrada, deseja adicionar?" | translate }}
            </ion-item>
          </ion-list>
        </ion-content>

        <form [formGroup]="profissaoForm" *ngIf="filteredOptions.length === 0">
          <ion-footer>
            <ion-row>
              <ion-col>
                <ion-button expand="block" (click)="cancelar()">
                  {{ "Cancelar" | translate }}
                </ion-button>
              </ion-col>

              <ion-col *ngIf="!(field.configAdd ?? false)">
                <ion-button expand="block" (click)="addProfissao()">
                  {{ "Adicionar" | translate }}
                </ion-button>
              </ion-col>
            </ion-row>
          </ion-footer>
        </form>

        <ion-footer class="ion-no-border">
          <ion-grid>
            <ion-row>
              <ion-col size="12">
                <ion-button
                  shape="round"
                  expand="block"
                  class="btn-default"
                  *ngIf="getSelectedLabel() !== null"
                  expand="block"
                  (click)="limparSelecao()"
                >
                  {{ "Limpar" | translate }}
                </ion-button>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-footer>
      </ng-template>
    </ion-modal>

    <div class="validation-errors">
      <ng-container *ngFor="let validation of field.validations">
        <div
          class="error-message"
          *ngIf="
            group.get(field.name)?.hasError(validation.name) &&
            (group.get(field.name)?.dirty || group.get(field.name)?.touched)
          "
        >
          {{ "Campo Obrigatório" | translate }}
        </div>
      </ng-container>
    </div>
  `,
  styles: [
    `
      ion-item {
        --inner-border-width: 0px;
        margin: 0 20px;
      }

      .gradient-extendido {
        height: 30px !important;
      }

      ion-searchbar {
        --background: #f7f7f7;
        --color: #000;
        --placeholder-color: #000;
        --icon-color: var(--theme-color4);
        --clear-button-color: #000;
        --border-radius: 24px;
        padding-inline-start: 22px !important;
        padding-inline-end: 22px !important;
      }

      .edit-text {
        width: 50%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      ion-radio {
        --color-checked: var(--theme-color4);
      }

      ion-radio.ios::part(container) {
        width: 20px;
        height: 20px;
        border: 2px solid #ddd;
        border-radius: 10px;
      }

      .radio-checked.ios::part(container) {
        border-color: var(--theme-color4);
      }

      .error-message {
        padding-bottom: 10px !important;
        font-size: 12px !important;
      }

      .validation-errors {
        margin-left: 35px;
      }
    `,
  ],
  standalone: true,
  imports: [TranslateModule, IonicModule, ReactiveFormsModule, CommonModule, FormsModule],
})
export class ProfissaoSelectComponent implements OnInit {
  @Input() field: FieldConfig;
  @Input() group: FormGroup;
  @Input() idInstituicao: number;
  @ViewChild("searchbar", { static: false }) searchbar?: IonSearchbar;

  profissaoForm: FormGroup;
  searchText: string = "";
  filteredOptions: any[] = [];
  isModalOpen: boolean = false;
  mostrarAddTemplate: boolean = false;

  public results = [];

  constructor(
    private formBuilder: FormBuilder,
    public pessoaProvider: PessoaProvider,
    public userProvider: UserProvider,
    public cadastroProvider: CadastroProvider,
    public navParams: NavParams
  ) {
    this.idInstituicao = this.navParams.get("idInstituicao");
    this.profissaoForm = this.formBuilder.group({
      profissao: new FormControl("", Validators.required),
    });
  }

  ngOnInit(): void {
    this.filteredOptions = this.field.options ?? [];
  }

  openModal() {
    this.filteredOptions = this.field.options ?? [];
    this.searchText = "";
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
  }

  limparSelecao() {
    this.group.get(this.field.name)?.reset();
    this.profissaoForm.get("profissao")?.reset();
    this.field.value = null;
  }

  filterProfissoes(event: Event) {
    const target = event.target as HTMLIonSearchbarElement;
    const query = target.value?.toLowerCase() || "";

    this.searchText = query;

    this.filteredOptions = (this.field.options ?? []).filter((item: any) => item.label.toLowerCase().includes(query));

    if (this.filteredOptions.length === 0 && query.length > 0) {
      this.profissaoForm.get("profissao")?.reset();
      this.profissaoForm.get("profissao")?.setValue(query);
      this.mostrarAddTemplate = true;
    } else {
      this.mostrarAddTemplate = false;
    }
  }

  selectProfissao(profissao: any) {
    this.group.get(this.field.name)?.setValue(profissao.value);
    this.closeModal();
  }

  addProfissao() {
    const profissao = this.profissaoForm.get("profissao")?.value;
    const provider = this.userProvider.loggedUser ? this.pessoaProvider : this.cadastroProvider;

    provider.addProfissao(profissao, this.idInstituicao).subscribe((data: any) => {
      this.field.options?.push(data);
      this.profissaoForm.get("profissao")?.reset();
      this.filteredOptions?.push(data);
    });
  }

  cancelar() {
    this.searchText = "";
    this.filteredOptions = this.field.options ?? [];
    this.profissaoForm.get("profissao")?.reset();
    this.mostrarAddTemplate = false;
    if (this.searchbar) {
      this.searchbar.value = "";
    }
  }

  getSelectedLabel(): string | null {
    const value = this.group.get(this.field.name)?.value;
    const selected = (this.field.options ?? []).find((opt) => String(opt.value) === String(value));
    return selected ? selected.label : null;
  }
}
